(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.RwadyInteractionUtils = api;
    if (root.document) {
      api.installProductCarouselTouchStop(root);
      api.installMobileViewportLock(root);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const calculateCartCount = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((total, item) => {
      const quantity = Number.parseInt(item?.quantity, 10);
      return total + (Number.isFinite(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
  };

  const formatCartCount = (count) => {
    const normalizedCount = Math.max(0, Number.parseInt(count, 10) || 0);
    return normalizedCount > 99 ? '99+' : String(normalizedCount);
  };

  const shouldAnimateCartTransfer = ({ confirmed, buyNow, reducedMotion }) => (
    Boolean(confirmed) && !buyNow && !reducedMotion
  );

  const shouldStopProductAutoMotion = (pointerType) => (
    pointerType === 'touch' || pointerType === 'pen'
  );

  const installProductCarouselTouchStop = (scope) => {
    const doc = scope?.document;
    if (!doc || scope.__rwadyProductTouchStopInstalled) return;
    scope.__rwadyProductTouchStopInstalled = true;

    doc.addEventListener('pointerdown', (event) => {
      if (!shouldStopProductAutoMotion(event.pointerType)) return;
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      const grid = target.closest(
        '.rwady-content-products__module[data-product-style="compact"] .rwady-content-products__grid'
      );
      if (!grid) return;
      const module = grid.closest('.rwady-content-products__module');
      if (!module || module.dataset.touchMotionStopped === 'true') return;

      module.dataset.touchMotionStopped = 'true';
      module.dispatchEvent(new CustomEvent('rwady-content-products:stop-motion'));
      grid.style.scrollBehavior = 'auto';
      grid.style.scrollSnapType = 'inline proximity';
    }, { capture: true, passive: true });
  };

  const installMobileViewportLock = (scope) => {
    const doc = scope?.document;
    if (!doc || doc.getElementById('RwadyMobileViewportLock')) return;
    const style = doc.createElement('style');
    style.id = 'RwadyMobileViewportLock';
    style.textContent = `
      @media (max-width: 749px) {
        html {
          width: 100%;
          max-width: 100%;
          overflow-x: hidden !important;
          overscroll-behavior-x: none;
        }
        body {
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden !important;
          overscroll-behavior-x: none;
          position: relative;
        }
        #MainContent {
          width: 100%;
          max-width: 100%;
          overflow-x: clip;
        }
        #MainContent > .shopify-section,
        #MainContent > [id^="shopify-section-"] {
          max-width: 100%;
        }
        .rwady-content-products__module[data-layout="carousel"] .rwady-content-products__grid {
          overscroll-behavior-inline: contain;
          -webkit-overflow-scrolling: touch;
        }
      }
    `;
    (doc.head || doc.documentElement).appendChild(style);
  };

  return {
    calculateCartCount,
    formatCartCount,
    shouldAnimateCartTransfer,
    shouldStopProductAutoMotion,
    installProductCarouselTouchStop,
    installMobileViewportLock,
  };
});
